import { InvoiceTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1960. 請求タスクコメント登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  content: string;
  content_json: string;
  parent_id?: number;
};

const createInvoiceTaskComment = (props: Props): Promise<InvoiceTaskComment> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_comments`,
    props
  );
};

export const useCreateInvoiceTaskComment = () => {
  return useMutation({
    mutationFn: createInvoiceTaskComment
  });
};